import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { varFade, MotionViewport } from 'src/components/animate';

// ----------------------------------------------------------------------

export default function AboutVision() {
  return (
    <Box
      sx={{
        bgcolor: 'background.neutral',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        minHeight: { xs: 220, md: 300 },
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 0 },
      }}
    >
      <Container component={MotionViewport}>
        <m.div variants={varFade().inUp} style={{ willChange: 'transform, opacity' }}>
          <Typography
            variant="h5"
            sx={{
              maxWidth: 800,
              mx: 'auto',
              fontWeight: 600,
              lineHeight: 1.6,
              fontFamily: (theme) => theme.typography.fontSecondaryFamily,
              fontSize: { xs: '1.2rem', md: '1.5rem' },
            }}
          >
            My vision is to create seamless, user-focused digital experiences that inspire
            innovation and support a vibrant tech community.
          </Typography>
        </m.div>
      </Container>
    </Box>
  );
}
